import fileSys from "../../fileoprators/fileSystem";
import SettingsOprator from "../settingsoprator";
const DEFAULTSET = {
  lhaa: "HOA",
  order: 6,
  diameter: 4
};
class ZernikeSet extends SettingsOprator {
  constructor() {
    super(fileSys.getTopographyCfgPath("zernikeSetSttings.json"), DEFAULTSET);
  }
  getZernikeSetSettings() {
    return this.getSettings();
  }
  saveZernikeSetSettings(settings) {
    this.saveSettings(settings);
  }
}
export default ZernikeSet;



// WEBPACK FOOTER //
// ./src/settings/topography/zernikeSet.js